module.exports = __webpack_public_path__ + "img/down-xl2.a3f0a6d8.png";